import { render, staticRenderFns } from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=template&id=428ca628"
import script from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=script&lang=js"
export * from "./tetapkanpenyeliaprosesanoperasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports